var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconLinks"},_vm._l((_vm.iconLinks),function(iconLink){return _c('a',{key:iconLink.title,staticClass:"iconLinks__iconLink",attrs:{"href":iconLink.url,"title":iconLink.title,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.getRequiredImagePath(
          iconLink.imageLocation,
          iconLink.title,
          iconLink.imageType
        ),"alt":("To Dust " + (iconLink.title))}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }